export enum Actions {
    SAVE_FEEDBACK = 'SAVE_FEEDBACK',
}
